import { useQuery } from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'

export const useGetResourceById = (id: number) => {
  const get = useTypedApiClient({
    path: '/admin/resources/{id}',
    method: 'get',
  })

  return useQuery({
    queryKey: ['/admin/resources', id],
    queryFn: async () => {
      const { data } = await get({ id })
      return data
    },
  })
}
